
export const VALID_SALARY_HEADERS = [
  "employee_id",
  "employee_name",
  "department",
  "designation",
  "joining_Date",
  "Basic Salary",
  "HRA",
  "Allowance",
  "Special Allowance",
  "RNR/Bonus",
  "Total",
  "Salary Advance",
  "Total Earnings",
  "PF",
  "Insurance",
  "PT",
  "ESI",
  "Advance recovery",
  "TDS",
  "Total Deductions",
  "Net Salary"
];
